/*
 * Overview Table
 */
table.birding-agg {
  td, th {
    padding: 0 10px;
    height: 40px; /* Better "taxon" table */
  }
  td:first-child {
    text-align: right;
  }
}
